import { CheckCircle2, Circle, AlertCircle } from 'lucide-react';

export const CustomizationSectionRail = ({
  sections = [],
  activeSectionId,
  onSelect,
  missingBySection = {},
}) => {
  return (
    <aside
      className="w-full rounded-2xl border border-slate-200/70 bg-slate-50/80 p-3"
      data-testid="customization-section-rail"
    >
      <div className="mb-3 px-2">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500" data-testid="customization-rail-title">
          Sections
        </p>
      </div>

      <div className="space-y-1.5" data-testid="customization-rail-list">
        {sections.map((section, index) => {
          const missingCount = (missingBySection[section.category_id] || []).length;
          const isActive = section.category_id === activeSectionId;
          const isComplete = missingCount === 0;

          return (
            <button
              key={section.category_id}
              type="button"
              className={`w-full rounded-xl border px-3 py-2.5 text-left transition-colors ${
                isActive
                  ? 'border-amber-300 bg-amber-50'
                  : 'border-transparent bg-white hover:border-slate-200 hover:bg-slate-100'
              }`}
              onClick={() => onSelect?.(section.category_id)}
              data-testid={`customization-rail-item-${section.category_id}`}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  {isComplete ? (
                    <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0" />
                  ) : isActive ? (
                    <AlertCircle className="h-4 w-4 text-amber-600 shrink-0" />
                  ) : (
                    <Circle className="h-4 w-4 text-slate-400 shrink-0" />
                  )}
                  <span className="text-sm font-medium text-slate-800 truncate">
                    {index + 1}. {section.name}
                  </span>
                </div>

                {missingCount > 0 && (
                  <span
                    className="rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-semibold text-rose-700"
                    data-testid={`customization-rail-missing-badge-${section.category_id}`}
                  >
                    {missingCount}
                  </span>
                )}
              </div>

              <p className="mt-1 text-xs text-slate-500" data-testid={`customization-rail-mode-hint-${section.category_id}`}>
                Step-by-step mode
              </p>
            </button>
          );
        })}
      </div>
    </aside>
  );
};
